import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const PETAL_COLORS = ["#F8B7B1", "#F6C7A8", "#FAD4D0", "#E7B7C8", "#F4A9A0"];

export default function WelcomeBurst({ name }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: 46 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: 12 + Math.random() * 20,
        dur: 3.4 + Math.random() * 2.6,
        delay: Math.random() * 1.6,
        sway: `${Math.random() * 180 - 90}px`,
        spin: `${Math.random() * 720 - 360}deg`,
        isHeart: i % 3 === 0,
        color: PETAL_COLORS[i % PETAL_COLORS.length],
      })),
    []
  );

  return (
    <div className="fixed inset-0 z-[80] pointer-events-none overflow-hidden" data-testid="welcome-burst">
      {pieces.map((p) =>
        p.isHeart ? (
          <Heart
            key={p.id}
            className="petal-fall fill-current"
            style={{
              left: `${p.left}%`,
              width: p.size,
              height: p.size,
              color: p.color,
              "--dur": `${p.dur}s`,
              "--delay": `${p.delay}s`,
              "--sway": p.sway,
              "--spin": p.spin,
            }}
          />
        ) : (
          <span
            key={p.id}
            className="petal-fall petal-shape"
            style={{
              left: `${p.left}%`,
              width: p.size,
              height: p.size,
              background: p.color,
              "--dur": `${p.dur}s`,
              "--delay": `${p.delay}s`,
              "--sway": p.sway,
              "--spin": p.spin,
            }}
          />
        )
      )}

      <motion.div
        initial={{ opacity: 0, scale: 0.85, y: 10 }}
        animate={{ opacity: [0, 1, 1, 0], scale: [0.85, 1, 1, 1.02], y: [10, 0, 0, -6] }}
        transition={{ duration: 3.4, times: [0, 0.15, 0.75, 1] }}
        className="absolute inset-x-0 top-[34%] flex flex-col items-center text-center px-6"
      >
        <span className="font-hand text-3xl text-[#D95F59]">welcome back, my love</span>
        <span className="font-display text-5xl md:text-6xl tracking-tight text-[#2A2726]">
          Hi {name} 💕
        </span>
      </motion.div>
    </div>
  );
}
